import SimpleArrowIcon from 'assets/icons/SimpleArrowIcon'

interface TextButtonProps {
  children: React.ReactNode
  handleFunction: () => void
  hasIconLeft?: boolean
  hasIconRight?: boolean
  isDisabled?: boolean
  otherIcon?: boolean
  isDropdown?: boolean
  isOpen?: boolean
  icon?: unknown
  color?: string
  className?: string
}

const TextButton = ({
  children,
  handleFunction,
  hasIconLeft = false,
  hasIconRight = false,
  isDisabled = false,
  otherIcon = false,
  isDropdown = false,
  isOpen = false,
  icon = null,
  color = null,
  className = 'p-1'
}: TextButtonProps) => (
  <button
    type='button'
    className={` 
      active:bg-gray-300 active:rounded  font-bold
      ${
        isDisabled
          ? 'opacity-50 active:bg-transparent hover:no-underline '
          : 'hover:underline'
      } flex items-center
      ${!!hasIconLeft && 'flex items-center w-full justify-center flex-row'}
      ${
        !!hasIconRight &&
        'flex items-center w-full justify-between flex-row-reverse'
      }
      ${color || 'text-purple-900'}
      ${className}`}
    onClick={(e) => {
      handleFunction()
      e.preventDefault()
    }}
    disabled={isDisabled}
  >
    {hasIconRight && (
      <span className='rounded-full flex items-center justify-center border border-gray-300 h-6 w-6'>
        <SimpleArrowIcon />
      </span>
    )}
    {otherIcon && icon}
    {children}
    {isDropdown && (
      <span className='rounded-full flex items-center justify-center border border-gray-300 h-6 w-6'>
        <SimpleArrowIcon
          className={`w-5 transform duration-400 ease-in-out transition-all ${
            isOpen ? '-rotate-180' : 'rotate-180'
          }`}
        />
      </span>
    )}
  </button>
)

export default TextButton
